export const JWT_TOKEN = "accessToken";
export const BACKEND_URL = process.env.REACT_APP_URL_BASE_BACKEND;
export const SIZE_LIMIT_PDF = process.env.REACT_APP_SIZE_LIMIT_PDF_MB; 
export const NUMBER_OF_DECIMALS = process.env.REACT_APP_NUMBER_OF_DECIMALS || 1;
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

export const NAME_TOKEN = "token_system_conalep";
export const TOKEN_EGRESADOS = "token_egresados";
export const TOKEN_EMP_BY_EGRESADOS = "sistema_empresa_egre";

export const GET_TOKEN_SYSTEM = () => localStorage.getItem(NAME_TOKEN);
export const GET_TOKEN_EGRESADOS = () => localStorage.getItem(TOKEN_EGRESADOS);
export const GET_TOKEN_EMP_BY_EGRESADOS = () => localStorage.getItem(TOKEN_EMP_BY_EGRESADOS);
export const REMOVE_TOKEN_SYSTEM  = () => localStorage.getItem(NAME_TOKEN) && localStorage.removeItem(NAME_TOKEN);
export const REMOVE_TOKEN_EGRESADOS  = () => localStorage.getItem(TOKEN_EGRESADOS) && localStorage.removeItem(TOKEN_EGRESADOS);
export const REMOVE_TOKEN_EMP_BY_EGRESADOS  = () => localStorage.getItem(TOKEN_EMP_BY_EGRESADOS) && localStorage.removeItem(TOKEN_EMP_BY_EGRESADOS);

export const ENABLED_USER = "activar";
export const DISABLED_USER = "suspender";
export const ACCEPT_USER = "aceptar";

export const COLOR_WARNING = "#F3A600";
export const COLOR_SUCCESS = '#095253';
export const COLOR_ERROR = "#FF1502"; 

export const ID_SISTEMA_CUADRO_MANDO = 1; // ID de la base de datos del sistema CUADRO DE MANDO
export const ID_DIRECCION_GENERAL = "3155280"; // ID correspondiente a la Dirección General en la tabla c_plantel de la base de datos del sistema CUADRO DE MANDO

export const CATALOGO_MENSAJES = {
  error404: "Error en el servidor de datos. Por favor, inténtalo de nuevo.",
  Requestmenssage: "¡Gracias por proporcionar tus datos! Estamos procesando tu solicitud de acceso al Tablero de Comando Integral. Pronto recibirás un correo electrónico de confirmación con los detalles de tu cuenta y las instrucciones para acceder al tablero.",
  accessRequestTitle: "Solicitud de acceso",
  LOG_AUTH: `¿Estás seguro de cerrar sesión? \n Por razones de seguridad, se cerrará la sesión de tu cuenta de Microsoft.`,
  TOKEN_EXPIRED: "Su token ha expirado. \n Por razones de seguridad, se cerrará la sesión de tu cuenta de Microsoft.",
};

/**
 * Enum de sistemas disponibles en la base de datos.
 *
 * Valores - Clave_Sistema:
 * - CUADRO_MANDO: "CMI"
 * - EGRESADOS: "EGRESADOS"
 */

export const CATALOGO_SISTEMAS = {
  TODOS: "ALL",
  CUADRO_MANDO: "CMI",
  EGRESADOS: "EGRESADOS",
};
 


export const FILTRO_CATEGORIAS_DE_PLANTELES = [
  {
    "id": "ALL",
    "data": "Todos",
  },
  {
    "id": "DG",
    "data": "Dirección General",
  },
  {
    "id": "PL",
    "data": "Planteles",
  }
]
 
export const colPropsSpan24 = {
  xs: { span: 24 },
  md: { span: 24 },
};
export const colPropsSpan16 = {
  xs: { span: 24 },
  md: { span: 16 },
};

export const colPropsSpan12 = {
  xs: { span: 24 },
  md: { span: 12 },
};
export const colPropsSpan8 = {
  xs: { span: 24 },
  md: { span: 8 },
};

export const colPropsSpan6 = {
  xs: { span: 24 },
  md: { span: 6 },
};

export const FORM_ITEM_LAYOUT = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 6,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 14,
    },
  },
};
 

export const CATALOGO_ESTADOS_ACTIVO_INACTIVO = [
  {
    "id": 2,
    "data": "Activo",
  },
  {
    "id": 1,
    "data": "Inactivo",
  },
]; 